<template>
  <!-- NOTE: IF POSSIBLE CHANGE ALL THE FUCNTIONS WE ARE USING INLINE TO METHODS -->
  <!-- first card -->
  <div>
    <div class="col-12 sample-card">
      <div class="col-12 view-title">Sample Inspection</div>
      <!-- row containing the sample tabs -->
      <div class="row col-11 sample-tabs">
        <div class="row tabs-wrapper">
          <div
            class="sample-tab"
            v-for="(sample, index) in Number(samplecount)"
            :key="index"
            :class="{ 'test': index==samplecount-1,  'active': index==sampleIndex}"
            @click="changeSample(index)"
          >Sample {{sample}}</div>
        </div>
      </div>
      <!--sample tabs end -->
      <!-- Sample weight and pulp temp -->
      <div class="row input-section col-12">
        <div class="input-field col-3">
          <label class="input-label">Sample Weight (lb)</label>
          <input
            ref="sample_weight"
            type="text"
            v-model="sample_weight"
            @change="checkSampleWeight"
          />
        </div>
        <div class="input-field col-3">
          <label class="input-label">Pulp temperature(&deg;F)</label>
          <input type="text" v-model="pulp_temperature" />
        </div>

        <div class="input-field col-3">
          <label class="input-label">Specific Gravity</label>
          <input type="text" v-model="specific_gravity" />
        </div>
      </div>
      <!-- Sample weight and pulp temp ends -->
    </div>
    <!-- first card ends -->
    <button
      class="open-card"
      :class="{ 'open': openBasicReqs }"
      @click="openBasicReqs=!openBasicReqs"
    >{{openBasicReqs ? '-' : '+' }} Basic Requirements</button>
    <!-- second card (Basic Requirements) -->
    <div class="col-12 sample-card basreq-card" :class="{ 'closed': !openBasicReqs }">
      <div class="col-12 pl-4 card-title">Basic Requirement</div>
      <div class="row input-section col-12">
        <div class="input-field col-3">
          <label class="input-label">Firmness</label>
          <dropdown
            :optionlist="basicRequirementOptions?basicRequirementOptions.firmness:[]"
            @select="function(item){basicRequirements.firmness=item.option}"
            :disabled="noEditFlag"
            :defaultSelected="basicRequirements.firmness"
          ></dropdown>
        </div>
        <div class="input-field col-3">
          <label class="input-label">Cleanness</label>
          <dropdown
            :optionlist="basicRequirementOptions?basicRequirementOptions.cleanness:[]"
            @select="function(item){basicRequirements.cleanness=item.option}"
            :disabled="noEditFlag"
            :defaultSelected="basicRequirements.cleanness"
          ></dropdown>
        </div>
        <div class="input-field col-3">
          <label class="input-label">Shape</label>
          <dropdown
            :optionlist="basicRequirementOptions?basicRequirementOptions.shape:[]"
            @select="function(item){basicRequirements.shape=item.option}"
            :disabled="noEditFlag"
            :defaultSelected="basicRequirements.shape"
          ></dropdown>
        </div>
        <div class="input-field col-3">
          <label class="input-label">Maturity</label>
          <dropdown
            :optionlist="basicRequirementOptions?basicRequirementOptions.maturity:[]"
            @select="function(item){basicRequirements.maturity=item.option}"
            :disabled="noEditFlag"
            :defaultSelected="basicRequirements.maturity"
          ></dropdown>
        </div>
        <div class="input-field col-3">
          <label class="input-label">Skinning</label>
          <dropdown
            :optionlist="basicRequirementOptions?basicRequirementOptions.skinning:[]"
            @select="function(item){basicRequirements.skinning=item.option}"
            :disabled="noEditFlag"
            :defaultSelected="basicRequirements.skinning"
          ></dropdown>
        </div>
      </div>
    </div>
    <!-- second card ends -->
    <button
      class="open-card"
      :class="{ 'open': showBagCount }"
      @click="showBagCount=!showBagCount"
    >{{showBagCount ? '-' : '+' }} Bag Counts</button>
    <!-- second card (Bag Counts) -->
    <div class="col-12 sample-card basreq-card" :class="{ 'closed': !showBagCount }">
      <div class="col-12 pl-4 card-title">Bag Count</div>
      

      <div class="row input-section col-12">
        <div class="col-2">
          <label for="bagCount">Bag Count</label>
          <select
        name="bagCount"
        class="form-control mb-2"
        placeholder="Select Bag Count"
        :value="bagCount.length"
        @change="updateBagCount"
      >
        <option v-for=" index in 10" :key="index" :value="index" >{{index}}</option>
      </select>
        </div>
        <table class="table table-bordered" v-if="bagCount.length">
          <thead>
            <th v-for="(elem, index) in bagCount" :key="index">Bag {{index+1}}</th>
          </thead>
          <tbody>
            <th v-for="(elem, index) in bagCount" :key="index">
              <input
                type="number"
                class="form-control"
                v-model="bagCount[index]"
              />
            </th>
          </tbody>
        </table>
      </div>
    </div>
    <!-- second card ends -->
    <div
      class="open-card new_padding"
      :class="{ 'open': openSizeDesig }"
      @click="openSizeDesig=!openSizeDesig"
    >{{openSizeDesig ? '-' : '+' }} Size Designation</div>
    <!-- third card (size desig) -->
    <div class="col-12 sample-card size-desig" :class="{ 'closed': !openSizeDesig }">
      <div class="col-12 pl-4 card-title">Type 1</div>
      <!-- size desig type 1-->
      <div class="row input-section col-12">
        <table class="table table-bordered">
          <thead>
            <th class="input-field col" style="width:15%">
              <label class="input-label">Size Designation</label>
            </th>

            <th class="input-field col-1" style="width:10%">
              <label class="input-label">Min Weight</label>
            </th>

            <th class="input-field col-1" style="width:10%">
              <label class="input-label col">Max Weight</label>
            </th>
            <th class="input-field col-1" style="width:10%">
              <label class="input-label">Undersize(lb)</label>
            </th>

            <th class="input-field col-1" style="width:10%">
              <label class="input-label">Oversize(lb)</label>
            </th>

            <th class="input-field col-1" style="width:5%">
              <label class="input-label">Status</label>
            </th>
          </thead>
          <tbody>
            <tr>
              <td>
                <dropdown
                  :optionlist="Object.keys(type1Inputs.sizeDesignation )"
                  :disabled="noEditFlag"
                  @select="setSizeDesigRange"
                  :defaultSelected="type1.sizeRange"
                ></dropdown>
              </td>
              <td>
                <input type="text" disabled v-model="type1.minWeight" />
              </td>
              <td>
                <input type="text" disabled v-model="type1.maxWeight" />
              </td>
              <td>
                <input
                  type="number"
                  v-model.number="type1.underSize"
                  :disabled="noEditFlag"
                  min="0"
                  max="100"
                  step="0.01"
                  @change="changeValueSizeDesig('underSize')"
                />
                <span>{{Math.round((type1.underSize/sample_weight)*10000)/100}}%</span>
              </td>
              <td>
                <input
                  type="number"
                  :disabled="noEditFlag"
                  v-model.number="type1.overSize"
                  min="0"
                  step="0.01"
                  max="100"
                  @change="changeValueSizeDesig('overSize')"
                />
                <span>{{Math.round((type1.overSize/sample_weight)*10000)/100}}%</span>
              </td>
              <td
                style="padding-left: 0.75rem;padding-right: 0.75rem;display: table-cell;text-align: center;vertical-align: middle;"
                class="table-row-cell passed"
                v-if="type1.undersizeThreshold >= (type1.underSize/sample_weight)*100 && type1.oversizeThreshold >= (type1.overSize/sample_weight)*100 "
              >Passed</td>
              <td
                class="table-row-cell failed"
                style="padding-left: 0.75rem;padding-right: 0.75rem;display: table-cell;text-align: center;vertical-align: middle;"
                v-else
              >Failed</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12 pl-4 mb-4 card-title">Type 2</div>
      <div class="row col-12">
        <div class="add-range">
          <button class="add-range-button" @click="addType2">Add Range</button>
        </div>
      </div>
      <div class="size-table-title row col-12" v-if="type2.length">
        <div class="table-title-cell col-3">Size</div>
        <div class="table-title-cell row col-7">
          <div class="col-6"></div>
          <div class="col-6"></div>
        </div>
        <div class="table-title-cell col-2 no-right">Status</div>
      </div>
      <!-- type2 table -->
      <div
        v-for="(size,index) in type2"
        :class="['size-table-row', 'row', 'col-12',hasWeight?'sizeA':'']"
        :key="index"
      >
        <div class="table-row-cell inner col-3">
          <div class="input-field col-10">
            <dropdown
              :optionlist="Object.keys(type2Inputs)"
              :index="index"
              @select="item=>setType2(index, item)"
              :defaultSelected="type2[index].key"
            ></dropdown>
            <br />
            <br />
            <div
              class="help-text"
              v-for="description in size.description"
              :key="description"
            >*{{description}}</div>
          </div>
        </div>
        <div class="table-row-cell row col-7">
          <div :class="['table-row-cell','inner', 'row','col-6' ]">
            <div class="input-field col">
              <label class="input-label">Min. Diameter</label>
              <input type="text" disabled v-model="size.minDiameter" />
            </div>
            <div class="input-field col">
              <label class="input-label">Max. Diameter</label>
              <input type="text" disabled v-model="size.maxDiameter" />
            </div>
            <div class="input-field col" v-if="size.hasWeight">
              <input class="radio-button" id="radio1" type="radio" name="size" />
              <label for="radio1">6oz</label>
              <br />
              <input class="radio-button" id="radio2" type="radio" name="size" />
              <label for="radio2">2-1/2in</label>
            </div>
          </div>
          <div :class="['table-row-cell','inner','row', 'col-6' ,'no-right']">
             <div class="input-field col" v-if="size.hasWeight">
              <label class="input-label">
                Weight(lb) of 6oz or
                <span v-if="(!size.hasUnderSize)">
                  <br />
                </span> 2-1/2inch
              </label>
              <input
                type="number"
                style="width:60%;margin-right:10%"
                min="0"
                :max="sample_weight"
                step="0.01"
                placeholder="0.0"
                v-model="size.weight"
              />
              <span>{{isNaN(size.weight)?0:Math.round((size.weight/sample_weight)*10000)/100}}%</span>
            </div>
            <div class="input-field col type-size" style="padding-right:0" v-if="size.hasUnderSize">
              <label class="input-label">
                Undersize
                <span v-if="size.hasWeight">
                  <br />
                </span>(lb)
              </label>
              <input
                type="number"
                min="0"
                step="0.01"
                placeholder="0.0"
                v-model="size.underSize"
                @change="changeValueType2(index,'underSize')"
              />
              <span>{{Math.round((size.underSize/sample_weight)*10000)/100}}%</span>
            </div>
            <div class="input-field col type-size" v-if="size.hasOverSize">
              <label class="input-label">Oversize(lb)</label>
              <input
                type="number"
                min="0"
                step="0.01"
                placeholder="0.0"
                :max="sample_weight"
                v-model="size.overSize"
                @change="changeValueType2(index,'overSize')"
              />
              <span>{{Math.round((size.overSize/sample_weight)*10000)/100}}%</span>
            </div>
          </div>
        </div>
        <div class="table-row-cell row col-2 no-right">
          <div
            class="table-row-cell col-8 passed"
            v-if="size.underSizeThreshold >= (size.underSize/sample_weight)*100 && size.overSizeThreshold >= (size.overSize/sample_weight)*100 && size.weightThreshold <= (size.weight/sample_weight)*100"
          >Passed</div>
          <div class="table-row-cell col-8 failed" v-else>Failed</div>
          <div class="table-row-cell col-4 delete-cell">
            <img class="trashbin" src="@/assets/icons/trashbin.svg" @click="removeType2(index)" />
          </div>
        </div>
      </div>
    </div>
    <!-- size desig type 1 ends-->
    <!-- size desid ends -->
    <!-- fourth card (defects card) -->
    <div class="col-12 sample-card defects-card">
      <!-- defect type options-->
      <div class="col-12 pl-4 card-title">Defects</div>
      <div class="row col-11 sample-tabs">
        <div class="row col-lg-4 col-md-6 col-sm-12 tabs-wrapper">
          <div
            class="col-4 sample-tab"
            :class="{active: defectType=='external'}"
            @click="defectType='external';selectedDefects=external"
          >External</div>
          <div
            class="col-4 sample-tab"
            :class="{active: defectType=='internal'}"
            @click="defectType='internal';selectedDefects=internal"
          >Internal</div>

          <div
            class="col-4 sample-tab"
            :class="{active: defectType=='other'}"
            @click="defectType='other';selectedDefects=other"
          >Other</div>
        </div>
      </div>
      <!-- defect type options ends -->
      <div class="col-3 defect-type">Defect Type</div>
      <!-- remove inline styles later-->
      <div class="col-12 row defects">
        <div class="col-3 defects-list">
          <input v-model="searchDefect" type="search" />
          <div
            class="defect-option"
            v-for="(defect, index) in defectlist"
            :key="index"
            @click="selectDefect(defect,index)"
          >{{defect.name}}</div>
        </div>
        <div class="col-9 row selected-defects">
          <div class="size-table-title row col-12" v-if="Object.keys(selectedDefects).length">
            <div class="table-title-cell col-4">Defect Name</div>
            <div class="table-row-cell row col-6">
              <div class="col-6 table-title-cell">Damage(lb)</div>
              <div class="col-6 table-title-cell no-right">Serious Damage(lb)</div>
            </div>
            <div class="table-title-cell col-2 no-right">Status</div>
          </div>
          <div
            class="size-table-row row col-12"
            v-for="(defect, index) in selectedDefects"
            :key="index"
          >
            <div class="table-row-cell inner col-4">
              <div class="input-field col-10">
                {{defect.name}}
                <br />
                <span class="damage-hint">{{defect.description}}</span>
              </div>
            </div>
            <div class="table-row-cell row col-6">
              <div class="table-row-cell inner row col-6">
                <div class="input-field col-12">
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0.0"
                    v-model="defect.damage"
                    @change="changeValue(index, 'damage')"
                  />
                  <!-- note: make a seperate method to calculate percentages-->
                  {{Math.round((defect.damage/sample_weight)*10000)/100}}%
                  <br />
                </div>
              </div>
              <div class="table-row-cell inner row col-6 no-right">
                <div class="input-field col-12">
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0.0"
                    v-model="defect.seriousDamage"
                    @change="changeValue(index, 'seriousDamage')"
                  />
                  {{Math.round((defect.seriousDamage/sample_weight)*10000)/100}}%
                  <br />
                </div>
              </div>
            </div>
            <div class="table-row-cell row col-2 no-right">
              <!-- note: make a seperate method to calculate percentages (v-if in this case)-->
              <div
                class="table-row-cell col-7 passed"
                v-if="(((Number(defect.damage)+Number(defect.seriousDamage))/sample_weight)*100 <=threshold)"
              >Passed</div>
              <div class="table-row-cell col-7 failed" v-else>Failed</div>
              <div class="table-row-cell col-5 delete-cell">
                <img
                  class="trashbin"
                  src="@/assets/icons/trashbin.svg"
                  @click="removeDefect(index)"
                />
              </div>
            </div>
          </div>
          <div class="col-12 row defect-report" v-if="Object.keys(selectedDefects).length">
            <div class="col-4 total-damage">Total Damage</div>
            <div class="col-6 damage-percent">{{Math.round(totalDamage*100)/100}}%</div>
            <div class="col-2 defect-status passed" v-if="totalDamage <= threshold">Passed</div>
            <div class="col-2 defect-status failed" v-else>Failed</div>
          </div>
        </div>
      </div>
    </div>
    <!-- defects card ends -->
    <!-- last card (image card) -->
    <!-- @drop is being used to handle file upload on drag on drop -->
    <div
      class="col-12 sample-card image-upload-card"
      @drop.prevent="uploadImages"
      @dragover.prevent
    >
      <div class="col-12 pl-4 card-title">Upload Defects Images</div>
      <div class="col-12 row upload-image" v-if="!images.length">
        <div class="col-12 drop-image-title">Drop Files Here</div>
        <div class="choose-image col-12" @click="addImage">Choose image</div>
      </div>
      <div class="col-11 row image-upload" v-else>
        <div class="add-image-button" @click="addImage">Add</div>
        <div class="row col-12 image-row">
          <div class="image-card" v-for="(image, index) in images" :key="index">
            <img class="sample-image" :src="image.url" />
            <div class="image-details">
              <!-- <span>{{image.name}}</span> -->
              <div class="browse-label">
                Browse defects
                <img
                  src="@/assets/icons/trashbin.svg"
                  class="remove-image"
                  @click="removeImage(image,index)"
                />
              </div>
              <!-- removeditems prop is being used to only show dropdown options which aren't already selected -->
              <!-- WE ARE MAKING AN ARRAY WITH ALL THE SELECTED DEFECTS IN THE optionlist PROP ITSELF. MAKE IT INTO A METHOD -->
              <dropdown
                :optionlist="Object.values(external).map(defect => defect.name).concat(Object.values(internal).map(defect => defect.name)).concat(Object.values(internal).map(defect => defect.name))"
                :multiselect="true"
                :search="true"
                :removeditems="tags[index]"
                :index="index"
                @select="addTag"
              ></dropdown>
              <span class="added-tags-label">Added Defects</span>
              <div class="tag" v-for="(tag, tagindex) in tags[index]" :key="tagindex">
                <div class="tag-name">{{tag}}</div>
                <!-- splice is being used to remove the tag. make it a method if possible -->
                <div class="remove-tag" @click="tags[index].splice(tagindex, 1)">Remove</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- image card ends -->
    <div class="save-button" @click="showSampleWeightAlert">Save & Next</div>
    <sweet-modal ref="sweetmodal" icon="warning">
      Sample weight is {{sample_weight}},  Is it correct ? 
      <div class="row mt-4">
        <div class="save-button" @click="saveSample">Yes</div>
        <div class="save-button" @click="closeSampleWeightAlert">No</div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
var docId;
import dropdown from "@/components/dropdown/dropdown.vue";
import { SweetModal } from "sweet-modal-vue";
import Vue from "vue";
const _ = require("lodash");

export default {
  name: "PotatoSample",
  components: {
    dropdown,
    SweetModal,
  },
  data() {
    return {
      sample_weight: 20,
      pulp_temperature: "",
      basicRequirements: {
        firmness: "",
        cleanness: "",
        shape: "",
        maturity: "",
        skinning: "",
      },
      type1: {
        sizeRange: "",
        maxWeight: 0,
        minWeight: 0,
        overSize: 0,
        underSize: 0,
        status: true,
        underSizeThreshold: 0,
        ovrSizeThreshold: 0,
      },
      showBagCount: false,
      bagCount: [],
      type2: [],
      openBasicReqs: false, // opens basic reqs card on true
      openSizeDesig: false, // opens size desig card on true
      defectType: "external", // shows the corresponding defects
      searchDefect: "", // searches for the defect with the string user provided
      external: {}, //Selected external
      internal: {}, //Selected Images
      other: {}, //Selected Images
      imageCount: 0, // no of images uploaded
      images: [],
      tags: [],
      isMounted: false, // being used to stop the component from looking for undefined data
      saveButton: false,
      selectedDefects: {},
    };
  },
  computed: {
    // NOTE: REPLACE IF ELSE CONDITIONS FOR DEFCTTYPE WITH A SINGLE LINE FILTER METHOD WHICH FILTERS BYT HE DEFCT TYPE
    // returns the defects for the selected type and filtered by the search string
    bagCountChange(e,i){
      this.bagCount[i] = parseInt(e.target.value)
    },
    sampleIndex() {
      return this.$route.params.activeTab - 1;
    },
    //list all property for basicRequirements
    basicRequirementOptions() {
      return this.$store.state.sampleThresholds.basicInformation;
    },
    //list of size ranges
    type1Inputs() {
      return this.$store.state.sampleThresholds.type1;
    },
    type2Inputs() {
      return this.$store.state.sampleThresholds.type2;
    },
    defectlist() {
      let list = {};
      var searchPattern = this.searchDefect;
      list = _.clone(
        this.$store.state.sampleThresholds[this.defectType].values
      );
      // SEARCH FILTER
      for (let key in list) {
        if (!list[key].name.toLowerCase().includes(searchPattern.toLowerCase()))
          delete list[key];
      }

      return list;
    },
    // returns damage threshold
    threshold() {
      return this.$store.state.sampleThresholds[this.defectType].threshold;
    },
    // returns the no of tabs saved in the backend
    savedTabs() {
      return this.$store.state.savedTabs;
    },
    samplecount() {
      return this.$store.state.num_samples;
    },
    // calculates total damage (all damage percentages added)
    totalDamage() {
      var sum = 0;
      for (let i in this.selectedDefects) {
        sum +=
          Number(this.selectedDefects[i].damage) +
          Number(this.selectedDefects[i].seriousDamage);
      }
      sum = (sum / this.sample_weight) * 100;
      return sum;
    },
    noEditFlag() {
      return this.$store.state.nonEditflag;
    },
    prevRoute() {
      if (
        !this.$store.state.prevRoute.includes(`/sample`) &&
        !this.$store.state.prevRoute.includes("/generalInfo") &&
        !this.$store.state.prevRoute.includes("/summary/")
      ) {
        if (this.noEditFlag)
          this.$router.push(`/app/secure/inspectionSummary/summary`);
        else
          this.$router.push(
            `/app/secure/inspectionTemplate/generalInfo/potato`
          );
      }
      return this.$store.state.prevRoute;
    },
  },
  watch: {
    async sampleIndex(newVal, oldVal) {
      await this.refreshData();
    },
    prevRoute(newVal, oldVal) {
      if (!newVal.includes(`/sample`) && !newVal.includes("/generalInfo")) {
        if (this.noEditFlag)
          this.$router.push(
            `/app/secure/inspectionSummary/edit/samples/potato/${this.$route.params.docId}/1`
          );
        else
          this.$router.push(
            `/app/secure/inspectionTemplate/samples/potato/${this.$route.params.docId}/1`
          );
      }
      this.refreshData;
    },
  },
  methods: {

    // Updated bagcount array
    updateBagCount(e){
      let x = parseInt( e.target.value)
      this.bagCount = Array.apply(null, Array(x)).map(function (x, i) { return 0; })
    },
    // check if Sample weight is > 20
    checkSampleWeight(item) {
      if (this.sample_weight < 20) {
        this.$store.dispatch("showSnackbar", {
          msg: "Sample Weight should be greater than 20",
        });
        this.sample_weight = 20;
      }
    },
    async removeImage(image, index) {
      this.$store.dispatch("showLoader", true);
      await this.$store.dispatch("deleteSampleImage", {
        key: image.key,
        index,
        sampleIndex: this.sampleIndex,
      });
      this.images = this.$store.state.sampleStateData[this.sampleIndex].images;
      this.tags = this.$store.state.sampleStateData[this.sampleIndex].tags;
      this.$store.dispatch("showLoader", false);
    },
    // resets an input  to 0 if the total damage exceeds 100%
    changeValue(defectIndex, damageType) {
      if (Math.round(this.totalDamage * 100) / 100 > 100) {
        this.selectedDefects[defectIndex][damageType] = 0;
      }
    },
    changeValueSizeDesig(SizeType) {
      if (
        Math.round((this.type1[SizeType] / this.sample_weight) * 10000) / 100 >
        100
      ) {
        this.type1[SizeType] = 0;
      }
    },
    // populates type1 default values
    setSizeDesigRange(item) {
      if (item.option != this.type1.sizeRange) {
        this.type1 = {
          ...this.type1Inputs.sizeDesignation[item.option],
          sizeRange: item.option,
          overSize: 0,
          underSize: 0,
        };
      }
    },

    // add Type2 row
    addType2() {
      this.type2 = [
        ...this.type2,
        {
          key: "",
          underSize: 0,
          overSize: 0,
          weight: 0.0,
        },
      ];
    },

    changeValueType2(index, type) {
      //CHANGED
      if (
        (this.type2[index]["overSize"] + this.type2[index]["underSize"]) /
          this.sample_weight >
        1
      ) {
        this.type2[index][damageType] = 0;
      }
    },
    removeType2(index) {
      this.type2.splice(index, 1);
    },
    setType2(index, item) {
      let type2 = this.type2;
      if (type2[index].key != item.option) {
        if (!_.map(this.type2, "key").includes(item.option)) {
          type2[index] = {
            ...this.type2Inputs[item.option],
            key: item.option,
            underSize: 0,
            overSize: 0,
            weight: 0.0,
          };
          this.type2 = [...type2];
        } else this.type2[index] = { key: "" };
      }
    },
    // handles post calls to send the sample data
    saveData() {
      return new Promise(async (resolve, reject) => {
        /*
                    We are using an array to save sample data in which each samples data is stored at indexsample = Index = sample no - 1
                    But, as api calls uses sample no, we pass sampleIndex+1 instead of sampleIndex
                */
        let sampleState = {
          ...this.$store.state.sampleStateData[this.sampleIndex],
          basicRequirements: this.basicRequirements,
          internal: this.internal,
          external: this.external,
          other: this.other,
          type1: this.type1,
          type2: _.keyBy(this.type2, "key"),
          sample_weight: this.sample_weight,
          pulp_temperature: this.pulp_temperature,
          specific_gravity: this.specific_gravity,
          showBagCount : this.showBagCount,
          bagCount: this.bagCount.map(x=>parseInt(x)),
        };
        delete sampleState.images, sampleState.tags;

        await this.$store.dispatch("savePotatoSampleInfo", {
          sampleNo: this.sampleIndex + 1,
          sample: sampleState,
          docId: this.$route.params.docId,
        });

        // await this.$store.dispatch("fileUpload", {
        //   tab: this.sampleIndex + 1,
        //   images: _.clone(this.images)
        // });

        var tags = {};
        for (let i = 0; i < this.images.length; i++) {
          let key = this.images[i].key;
          let tag = this.tags[i];
          tags[key] = tag;
        }

        await this.$store.dispatch("saveImageTags", tags);
        resolve();
      });
    },
    // loads the data for the corresponding sampleno on changing between samples and for noEditFlag = true
    refreshData() {
      return new Promise(async (res, rej) => {
        await this.$store.dispatch("getSampleImages", {
          docId: this.$route.params.docId,
          tab: this.sampleIndex + 1,
          commodity: "potato",
        });
        this.images = this.$store.state.sampleStateData[
          this.sampleIndex
        ].images;
        this.tags = this.$store.state.sampleStateData[this.sampleIndex].tags;
        this.basicRequirements = this.$store.state.sampleStateData[
          this.sampleIndex
        ].basicRequirements;
        this.type1 = this.$store.state.sampleStateData[this.sampleIndex].type1;
        this.external = this.$store.state.sampleStateData[
          this.sampleIndex
        ].external;
        this.internal = this.$store.state.sampleStateData[
          this.sampleIndex
        ].internal;
        this.other = this.$store.state.sampleStateData[this.sampleIndex].other;
        this.pulp_temperature = this.$store.state.sampleStateData[
          this.sampleIndex
        ].pulp_temperature;
        this.specific_gravity = this.$store.state.sampleStateData[
          this.sampleIndex
        ].specific_gravity;
        this.type2 = Object.keys(
          this.$store.state.sampleStateData[this.sampleIndex].type2
        ).map((key) => ({
          key,
          ...this.type2Inputs[key],
          ...this.$store.state.sampleStateData[this.sampleIndex].type2[key],
        }));
        this.sample_weight = this.$store.state.sampleStateData[
          this.sampleIndex
        ].sample_weight;
        this.showBagCount = this.$store.state.sampleStateData[
          this.sampleIndex
        ].showBagCount;
        this.bagCount = this.$store.state.sampleStateData[
          this.sampleIndex
        ].bagCount;

        // await this.$store.dispatch("getImages", this.$route.params.docId);
        // this.images = this.$store.state.sampleStateData[this.sampleIndex].images;
        // this.imageCount = this.images.length;
        this.defectType = "external";
        this.selectedDefects = this.external;
        this.openBasicReqs = false; // opens basic reqs card on true
        this.openSizeDesig = false;
        res();
      });
    },
    // upload image on adding image (note: images also get saved on savepage. remove it)
    async uploadImages(e) {
      this.$store.dispatch("showLoader", true);

      var imageList = [];
      var images = [];
      for (var i = 0; i < e.dataTransfer.files.length; i++) {
        // NOTE: files.item() method for filelist object may change in the future ES standards. Keep an eye on it
        imageList.push(e.dataTransfer.files.item(i));
        images.push({
          url: URL.createObjectURL(imageList[i]),
          name: imageList[i].name,
          search: "",
          tags: [],
          file: imageList[i],
        });
      }
      await this.$store.dispatch("fileUpload", {
        tab: this.sampleIndex + 1,
        images: images,
        commodity: "potato",
        docId: this.$route.params.docId,
      });
      this.images = this.$store.state.sampleStateData[this.sampleIndex].images;
      this.tags = this.$store.state.sampleStateData[this.sampleIndex].tags;
      this.$store.dispatch("showLoader", false);
    },
    //Adding tags to an image
    addTag(tag) {
      this.tags[tag.index].push(tag.option);
    },
    //Uploading an image
    async addImage() {
      var input = document.createElement("input");
      input.type = "file";
      input.setAttribute("accept", "image/jpeg");
      input.setAttribute("multiple", "");
      var files = [];

      input.onchange = async (e) => {
        this.$store.dispatch("showLoader", true);
        files = e.target.files;
        let images = [];
        for (var i = 0; i < files.length; i++) {
          images.push({
            url: URL.createObjectURL(files[i]),
            name: files[i].name,
            search: "",
            tags: [],
            file: files[i],
          });
        }

        await this.$store.dispatch("fileUpload", {
          tab: this.sampleIndex + 1,
          images: images,
          commodity: "potato",
          docId: this.$route.params.docId,
        });
        this.images = this.$store.state.sampleStateData[
          this.sampleIndex
        ].images;
        this.tags = this.$store.state.sampleStateData[this.sampleIndex].tags;
        this.$store.dispatch("showLoader", false);
        // this.$store.commit("uploadImages", {
        //   tab: this.sampleIndex,
        //   imageIndex: this.imageCount,
        //   images: this.images
        // });
        // this.imageCount += files.length;
      };

      input.click();
    },
    // When a new defect is selected
    selectDefect(defect, index) {
      //defect: values from threshold, index: defect key
      if (!this.noEditFlag) {
        if (!this.selectedDefects[index]) {
          // if defect is already existing ignore it
          Vue.set(this.selectedDefects, index, {
            ...defect,
            damage: 0,
            seriousDamage: 0,
          });
        }
      }
    },
    // Remove and already existing defect
    removeDefect(index) {
      if (!this.noEditFlag) {
        Vue.delete(this.selectedDefects, index);
      }
    },
    // reloads the sample info on changing between the samples. Is also being used to load sample info for noEditFlag = true
    async changeSample(sampleno) {
      this.$store.dispatch("showLoader", true);

      if (sampleno <= this.savedTabs) {
        if (!this.saveButton) {
          await this.saveData();
        }

        await this.$store.dispatch("getSampleImages", {
          docId: this.$route.params.docId,
          tab: sampleno + 1,
          commodity: "potato",
        });

        this.images = this.$store.state.sampleStateData[sampleno].images;
        this.tags = this.$store.state.sampleStateData[sampleno].tags;
        this.saveButton = false;
        await this.$store.dispatch("getPotatoSamplesData", {
          docId: this.$route.params.docId,
          sampleNo: sampleno + 1,
        });
        if (this.noEditFlag)
          this.$router.push(
            `/app/secure/inspectionSummary/edit/samples/potato/${
              this.$route.params.docId
            }/${sampleno + 1}`
          );
        else
          this.$router.push(
            `/app/secure/inspectionTemplate/samples/potato/${
              this.$route.params.docId
            }/${sampleno + 1}`
          );
        // await this.refreshData(); // refreshdata is being called here to populate the recorded values for noEditFlag = true
        document.getElementsByClassName("midSection")[0].scrollTo(0, 0);

        $(".midSection").scrollTop(0);
      }

      this.$store.dispatch("showLoader", false);
    },
    //SHOW SAMPLE WEIGHT ALERT AFTER HITTING SAVE NEXT
    showSampleWeightAlert(){
      this.$refs.sweetmodal.open();
    },
    closeSampleWeightAlert(){
      this.$refs.sweetmodal.close();
    },
    //Save and Next action event
    async saveSample() {
      this.closeSampleWeightAlert()
      this.saveButton = true;
      this.$store.dispatch("showLoader", true);
      await this.saveData();

      this.$store.commit("updateSavedTab", this.sampleIndex);
      if (this.sampleIndex == this.samplecount - 1) {
        // pushes to summary when the last sample is saved
        if (!this.noEditFlag) {
          this.$router.push(
            `/app/secure/inspectionTemplate/summary/potato/${this.$route.params.docId}`
          );
        } else {
          this.$router.push(
            `/app/secure/inspectionSummary/edit/summary/potato/${this.$route.params.docId}`
          );
        }
        await this.$store.commit("setActiveTab", this.sampleIndex + 1);
        this.$store.commit("resetSavedTabs");

        return;
      } else this.changeSample(this.sampleIndex + 1);

      // this.sampleIndex++;
      this.$store.dispatch("showLoader", false);

      // $('html, body').animate({scrollTop: $("#TopSection").offset().top}, 2000);
    },
  },
  beforeDestroy: async function () {
    if (
      this.$route.params.docId &&
      this.$route.path.includes(this.$route.params.docId)
    ) {
    } else if (!this.noEditFlag && docId) {
      await this.$store.dispatch("deletePotatoReport", docId);
    }
  },
  async mounted() {
    this.$store.commit("setActiveTab", this.sampleIndex + 1);
    // FETCHES SAMPLE DATA
    await this.$store.dispatch("getPotatoSamplesData", {
      docId: this.$route.params.docId,
      sampleNo: this.sampleIndex + 1,
    });

    await this.refreshData(); // refreshdata is being called here to populate the recorded values for noEditFlag = true

    this.$store.dispatch("showLoader", false);
    /* CHECKS WEATHER THE CONTENT IS OF SAME SAMPLE
     * This is for back button of browser. Might become redundant in later versions
     */
    if (
      this.$route.params.activeTab > 0 &&
      this.sampleIndex != this.$route.params.activeTab - 1
    ) {
      this.changeSample(this.$route.params.activeTab - 1);
    }
    document.getElementsByClassName("midSection")[0].scrollTo(0, 0);
    $(".content-wrapper").scrollTop(0); //Scrolls to top page
    this.isMounted = true;
    docId = this.$route.params.docId;
  },
  async created() {
    this.$store.dispatch("showLoader", true);
    // setting the path (bread crumbs) that is being shown on the top
    this.$store.dispatch("getPotatoSamplesThreshold", {
      docId: this.$route.params.docId,
    }); // Fetches threshold and defects for commodity
    this.$store.commit("changePathLabel", {
      //Breadcrums
      view: "Create Inspection",
      categories: [
        { name: "General Inspection", focus: false },
        { name: "Sample Inspection", focus: true },
        { name: "Preview", focus: false },
        { name: "Report", focus: false },
      ],
    });
  },
};
</script>

<style scoped>
/* NOTE: IF POSSIBLE MINIMIZE THE RULES BY GROUPING THE RULES COMMON TO MANY OF THE ELEMENTS */
.row {
  width: 100%;
  padding-left: 30px;
  font-family: "Source Sans Pro", sans-serif;
}

.sample-card {
  background: #fff;
  box-shadow: 0px 1px 24px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  height: 250px;
  min-height: max-content;
  margin-bottom: 30px;
  padding: 0px;
  transition: 0.3s;
  overflow: hidden;
}

.view-title {
  font-family: "Source Sans Pro", sans-serif;
  height: 25%;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  color: #29342e;
  border-bottom: 1px solid #cacaca;
  padding: 0 0 0 30px;
  display: flex;
  align-items: center;
}

.sample-tabs {
  margin-left: 30px;
  height: 24%;
  padding-left: 15px;
  padding-top: 1.5%;
  background: #ffffff;
  border-bottom: 1px solid #24c656;
  /* cursor: pointer; */
}

.sample-tab {
  color: #24c656;
  height: 100%;
  width: 100px;
  border-right: 1px solid #24c656;
  font-size: 14px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sample-tab.active {
  background: #24c656;
  color: white;
}

.input-section {
  height: 50%;
  padding-top: 1.5%;
}

.input-field {
  margin-bottom: 10px;
}

input {
  background: #ffffff;
  border: 1px solid #b4b4b4;
  box-sizing: border-box;
  border-radius: 4px;
  height: 38px;
  width: 100%;
  line-height: 38px;
  padding-left: 5px;
}

.table-row-cell input[type="number"] {
  width: 60%;
  margin-right: 0px;
}

.input-label {
  width: 100%;
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #858585;
}

.tabs-wrapper {
  background: #ffffff;
  border: 1px solid #24c656;
  width: max-content;
  border-bottom: 0px;
  box-sizing: border-box;
  border-radius: 4px 4px 0px 0px;
  padding: 0px;
  margin-right: -1px;
}

.open-card {
  width: 162px;
  height: 38px;
  background: #24c656;
  border-radius: 4px;
  outline: none;
  transition: 0.3s;
  color: #fff;
}

.sample-card.closed {
  min-height: 0px !important;
  height: 0px;
  padding-bottom: 0px;
  overflow: hidden;
}

.open-card.open {
  border: 1px solid #24c656;
  background: transparent;
  color: #24c656;
  margin-bottom: 10px;
}

input[type="number"] {
  appearance: textfield;
  width: 60%;
  margin-right: 10%;
}

.size-desig input[type="number"] {
  width: 60%;
}

.defects-card {
  height: max-content;
  min-height: 600px;
}

.card-title {
  height: 52px;
  padding: 0px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  border-bottom: 1px solid #cacaca;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.defects-card .sample-tabs {
  height: 60px;
}

.size-desig .input-section {
  height: 160px;
  margin-left: 0px;
  padding-left: 15px;
}

.test {
  border: none;
}

.size-desig-table {
  height: 300px;
  padding: 0px;
  margin: 0px;
}

.size-desig {
  overflow: visible;
  height: auto;
  padding-bottom: 30px;
}

.size-desig.closed {
  overflow: hidden;
}

.size-table-title {
  height: 52px;
  background: #f2f2f2;
  margin-top: 20px;
  border: 1px solid #cacaca;
  border-radius: 4px 4px 0px 0px;
  border-bottom: 0px;
  display: flex;
  align-items: center;
}

.size-table-row {
  height: 145px;
  border: 1px solid #cacaca;
  border-radius: 0px 0px 4px 4px;
}

.size-table-row,
.size-table-title {
  margin-left: 30px;
  padding: 0px;
  width: 94.5%;
}

.table-title-cell {
  height: 100%;
  box-sizing: border-box;
  border-right: 1px solid #cacaca;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #29342e;
  padding: 0px 0px 0px 15px;
  margin: 0px;
  display: flex;
  align-items: center;
}

.size-table {
  border: 1px solid #cacaca;
  box-sizing: border-box;
  border-radius: 4px;
  overflow: hidden;
  padding: 0px;
  width: 95%;
  margin-left: 30px;
}

.defect-type {
  background: #f2f2f2;
  height: 40px;
  max-width: calc(25% - 7px);
  margin-left: 30px;
  border-radius: 4px;
  margin-top: 15px;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
}

.defects-list {
  margin-top: 15px;
  margin-left: 15px;
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 4px;
  height: max-content;
  background: #f2f2f2;
}

.defect-option:last-child {
  border-bottom: none;
}

.add-range-button {
  border: 1px solid #24c656;
  border-radius: 4px;
  color: #24c656;
  height: 40px;
  width: 95px;
}

.add-range {
  width: 95px;
  height: 40px;
  margin-left: auto;
}

.drop-image-title {
  font-style: normal;
  font-weight: 600;
  font-size: 55px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  color: #f2f2f2;
  height: 50%;
}

.choose-image {
  color: #24c656;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-decoration-line: underline;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 50%;
  cursor: pointer;
}

.upload-image {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 348px;
}

.selected-defects {
  height: max-content;
}

button {
  outline: none;
}

.image-upload-card {
  height: max-content;
  min-height: 400px;
  overflow: visible;
}

.trashbin {
  width: 30%;
  height: 30%;
}

.delete-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: none !important;
}

.radio-button {
  height: unset;
  width: 20px;
  margin-top: 20px;
}

.defect-option {
  color: #646464;
  border-bottom: 1px solid #cacaca;
  cursor: default;
  padding: 3px 0px 3px 0px;
}

.defect-option:hover {
  color: #24c656;
}

.save-button {
  margin-left: auto;
  border: 1px solid transparent;
  border-radius: 4px;
  color: white;
  background: #24c656;
  height: 40px;
  width: 133px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
}

.sample-image {
  width: 230px;
  height: 160px;
  margin: 0 auto;
}

.add-image-button {
  height: 40px;
  width: 90px;
  margin-left: auto;
  color: #24c656;
  border: 1px solid #24c656;
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-upload {
  margin: 0 auto;
  padding: 0px;
}

.image-card {
  width: 232px;
  height: max-content;
  background: #f2f2f2;
  border: 1px solid transparent;
  box-sizing: border-box;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  margin-right: 25px;
  margin-bottom: 30px;
  padding-bottom: 15px;
}

.image-details {
  padding: 5px 10px 10px 10px;
  color: #858585;
}

.image-details > span {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tag-list {
  background: #fff;
}

.tag {
  height: 20px;
  margin: 10px 0px 0px 0px;
}

.tag-name {
  width: 75%;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 100%;
  font-size: 12px;
  color: #646464;
}

.remove-tag {
  width: 20%;
  margin-left: 1%;
  border: 1px solid #e74c3c;
  color: #e74c3c;
  font-size: 10px;
  border-radius: 4px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;
  cursor: default;
}

.browse-label {
  color: #29342e;
  text-overflow: unset;
  margin: 5px 0px 5px 0px;
}

.remove-image {
  float: right;
}

.added-tags-label {
  font-size: 14px;
  margin-top: 50px;
  color: #29342e;
}
.select-unit-label {
  padding-left: 0px;
  display: flex;
  align-items: center;
}

.table-row-cell {
  height: 100%;
  box-sizing: border-box;
  border-right: 1px solid #cacaca;
  padding: 0px;
  margin: 0px;
  display: flex;
  align-items: center;
  align-content: flex-start;
}
.table-row-cell.inner {
  padding-top: 20px;
}

.type-1-title {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #29342e;
}

.defect-report {
  margin: 20px 0px 0px 30px;
  height: 50px;
  border: 1px solid #cacaca;
  border-radius: 4px;
  padding: 0px;
}

.total-damage {
  background: #f2f2f2;
}

.total-damage,
.damage-percent {
  border-right: 1px solid #cacaca;
}

.total-damage,
.damage-percent,
.defect-status {
  display: flex;
  padding-left: 15px;
  align-items: center;
}

.passed {
  background: #e0f7ea;
  color: #24c756;
}

.failed {
  background: #fce6e4;
  color: #e74c3c;
}

.passed,
.failed,
.damage-percent {
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: none !important;
}

.type1.passed {
  display: initial;
}
.damage-percent {
  justify-content: flex-end;
}

input:disabled {
  background: #fbfbfb;
}

.help-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  color: #b4b4b4;
}

.damage-hint {
  font-size: 12px;
  color: #b4b4b4;
}

.basreq-card {
  overflow: visible;
  padding-bottom: 30px;
}

.type-size input[type="number"] {
  width: 59%;
  margin-right: 4px;
}
.no-right {
  border-right: none;
}
.new_padding {
  padding-top: 7px;
  padding-left: 17px;
  cursor: pointer;
}
</style>
